import { render, staticRenderFns } from "./TalentQuiz.vue?vue&type=template&id=2a3e4fe4&scoped=true&"
import script from "./TalentQuiz.vue?vue&type=script&lang=js&"
export * from "./TalentQuiz.vue?vue&type=script&lang=js&"
import style0 from "./TalentQuiz.vue?vue&type=style&index=0&id=2a3e4fe4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a3e4fe4",
  null
  
)

export default component.exports